// import axios from 'axios';
//import router from '../router/index';
// import {MessageBox, Message} from 'element-ui';
// import {logOut} from '@/services/getData';
import store from '@/store/store';
axios.defaults.timeout = 30000;
axios.defaults.withCredentials = true; // 跨域默认不带cookie
axios.defaults.baseUrl = process.env.PROTOCOL + "://" + process.env.API_HOST + '/api';
// axios.defaults.baseUrl = '/api';
const isDev = process.env.NODE_ENV === 'development';
let prefix = isDev ?  'www' : location.host.substr(0,location.host.indexOf('.'));
const ENV = process.env.ENVIRONMENT;
import codepku from '@/utils/codepku';
let schoolWeb = process.env.SCHOOL_WEB;
console.log(schoolWeb);
console.log(prefix);

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  }
//   console.log(getCookie(`${prefix}_${ENV}_token`),ENV,prefix);
axios.interceptors.request.use(
	config => {
        let token = store.state.token;
        let cookie_token = getCookie(`school_${prefix}_${ENV}_token`);
        if (token !== cookie_token){
            token = cookie_token;
            store.commit('token', token);
        }
        // if(!token){
        //     store.commit('token', getCookie(`${prefix}_${ENV}_token`) ||'');
        //     token = store.state.token;
        // }

	    if(!(config.url.indexOf("http")>-1 || config.url.indexOf("https")>-1)){
            config.url = config.baseUrl + config.url;
            config.headers['Domain-Prefix'] = prefix ;
        }
        if (token && config.url !== 'https://local.codepku.com:26337/run') {
            config.headers.Authorization ="Bearer"+ token;
        }
         // TODO:this test1 should be removed in production env
		return config;
	}, err => {
		return Promise.reject(err);
	});

axios.interceptors.response.use(
	response => {
        // console.log(response,'respppppppppppp');
	    if (response.data.code == 200) {
			return response.data;
		} else if (response.data.status === 'OK'){
			return response.data;
		}else if(response.status == 200){
	        return response.data;
        }
	},
	error => {
        // console.log(error,'errrrrrrrrrr');
		if (error.response) {
            // console.log(error,'errorerror');
			switch (error.response.status) {
				case 400:
					break;
                case 401:
                    console.log(location.href);
                    if(location.href.indexOf('/m/upload_work') > 0){
                        // 如果在手机端，就不要显示那个弹窗
                        // localStorage.clear();
                        // let url = location.href;
                        // let res = encodeURI(url);
                        // window.location.href = process.env.PROTOCOL +"://"+ process.env.LOGIN_HOST +'/login?redirect_uri='+res;
                    } else {
                        // ELEMENT.MessageBox.alert('授权码过期，请重新登录', '未授权',{
                        //     confirmButtonClass:'登录',
                        //     callback:action => {
                        //         localStorage.clear();
                        //         // let url = location.href;
						// 		// let res = encodeURI(url);
                        //         // window.location.href = process.env.PROTOCOL +"://"+ process.env.LOGIN_HOST +'/login?redirect_uri='+res;
                        //         logOut(url).then(response=>{
                        //             localStorage.clear();
                        //             location.href = process.env.PROTOCOL +"://"+ process.env.LOGIN_HOST +'/login?redirect_uri='+res;
                        //         }).catch(error=>{
                        //             this.$message.error(error.message || '退出失败');
                        //         });
                        //     }
                        // });
                        // ELEMENT.MessageBox.alert('授权码过期，请重新登录', '未授权',{
                        //     confirmButtonClass:'登录',
                        //     callback:action => {
                                ELEMENT.Message.warning("登录信息过期，请重新登录");
                                localStorage.clear();
                                codepku.setCookie(`school_${prefix}_${ENV}_token`, '', -1);
                                let schoolUrl = schoolWeb.replace('*', prefix);
                                setTimeout(() => {
                                    // window.location.href = `${schoolUrl}/login?redirect_uri=${location.protocol}//${location.host}`;
                                    window.location.href = `${schoolUrl}/?redirect_uri=${location.protocol}//${location.host}`;

                                },800);//展示出提示后再跳转
                                // window.location.href = `${schoolUrl}/login?redirect_uri=${location.protocol}//${location.host}`;
                        //     }
                        // });
                        // window.location.href = '/login';
                    }

					break;
                case 403:
                // console.log(error.response.data.message,'aaaaaaaaaa');
                    error.response.message = error.response.data.message;
                    // ELEMENT.Message.error(error.response.data.message);
					break;
				case 404:
					break;
				case 422:
					var errorMessage = "";
					let errorData = error.response.data.data;
					if (errorData != "") {
						for (var item in errorData) {
							errorMessage += errorData[item];
						}
						ELEMENT.Message.error(errorMessage);
						error.response.message = errorMessage;
					}
					break;
				case 500:
					break;
			}
			//ELEMENT.Message.error(error.response.data);
			return Promise.reject(error.response.data);
		} else {
			ELEMENT.Message.error(error);
			return Promise.reject(error);
		}
	}
);
export default axios;



// WEBPACK FOOTER //
// ./src/config/axios.config.js